const normalizeTagValue = (value) => {
    if (value === null || value === undefined) return ''

    let normalized = value
    if (typeof normalized !== 'string') {
        normalized = normalized.toString()
    }
    normalized = normalized.trim().toLowerCase()
    if (normalized.normalize) {
        normalized = normalized.normalize('NFKC')
    }
    return normalized
}
module.exports.normalizeTagValue = normalizeTagValue

const variantType = variant => {
    if (!variant) return null
    if (typeof variant === 'string') return variant
    return variant.type || null
}
module.exports.variantType = variantType

module.exports.curatedTagsBaseFirebasePath = () => '/curated-tags'

module.exports.curatedTagsFirebasePath = variant => {
    const type = variantType(variant)
    const basePath = module.exports.curatedTagsBaseFirebasePath()
    if (!type) return basePath
    return `${basePath}/${type}`
}

const isCuratedTagRecord = tag => {
    if (!tag || typeof tag !== 'object' || Array.isArray(tag)) return false
    return tag.labels !== undefined || tag.enabled !== undefined || tag.sort !== undefined
}

const toCuratedTagsList = curatedTags => {
    if (!curatedTags) return []
    if (Array.isArray(curatedTags)) {
        return curatedTags
    }

    let hasDirectTags = false
    for (let id in curatedTags) {
        if (isCuratedTagRecord(curatedTags[id])) {
            hasDirectTags = true
            break
        }
    }

    let listById = {}
    for (let id in curatedTags) {
        if (!curatedTags[id]) continue
        if (hasDirectTags) {
            if (!isCuratedTagRecord(curatedTags[id])) continue
            listById[id] = {
                ...curatedTags[id],
                id: curatedTags[id].id || id,
            }
            continue
        }

        const variantTags = curatedTags[id]
        if (!variantTags || typeof variantTags !== 'object' || Array.isArray(variantTags)) continue

        for (let tagId in variantTags) {
            if (!variantTags[tagId] || !isCuratedTagRecord(variantTags[tagId])) continue
            if (listById[tagId]) continue
            listById[tagId] = {
                ...variantTags[tagId],
                id: variantTags[tagId].id || tagId,
            }
        }
    }
    return Object.keys(listById).map(id => listById[id])
}
module.exports.toCuratedTagsList = toCuratedTagsList

module.exports.flattenCuratedTags = curatedTags => {
    const flattened = {}
    toCuratedTagsList(curatedTags).forEach(tag => {
        if (!tag || !tag.id) return
        flattened[tag.id] = {
            ...tag,
        }
        delete flattened[tag.id].id
    })
    return flattened
}

module.exports.enabledCuratedTags = (curatedTags) => {
    return toCuratedTagsList(curatedTags)
        .filter(tag => tag && tag.id && tag.enabled !== false)
}

module.exports.buildCuratedTagLookup = (curatedTags) => {
    const byId = {}
    const byLabel = {}
    const enabledTags = module.exports.enabledCuratedTags(curatedTags)

    enabledTags.forEach(tag => {
        const id = tag.id.toString()
        byId[id] = tag

        const labels = tag.labels || {}
        for (let lang in labels) {
            const normalized = normalizeTagValue(labels[lang])
            if (!normalized || byLabel[normalized]) continue
            byLabel[normalized] = id
        }
    })

    return {
        enabledTags,
        byId,
        byLabel,
    }
}

module.exports.resolveRawTagToCuratedId = (rawValue, lookup) => {
    if (!lookup || !lookup.byLabel) return null
    return lookup.byLabel[normalizeTagValue(rawValue)] || null
}

module.exports.collectSiteRawTags = (site) => {
    const values = []

    if (site && site.items) {
        for (let i = 0; i < site.items.length; i++) {
            const item = site.items[i]
            if (item && item.name !== undefined && item.name !== null) {
                values.push(item.name)
            }
        }
    }

    if (site && site.tags) {
        for (let i = 0; i < site.tags.length; i++) {
            values.push(site.tags[i])
        }
    }

    return values
}

module.exports.resolveSiteCuratedTagIds = (site, lookup) => {
    const resolved = {}
    module.exports.collectSiteRawTags(site).forEach(rawValue => {
        const id = module.exports.resolveRawTagToCuratedId(rawValue, lookup)
        if (id) {
            resolved[id] = true
        }
    })
    return Object.keys(resolved)
}

module.exports.curatedTagLabel = (tag, language, fallbackLanguage = 'en') => {
    if (!tag) return ''
    const labels = tag.labels || {}
    if (language && labels[language]) return labels[language]
    if (fallbackLanguage && labels[fallbackLanguage]) return labels[fallbackLanguage]

    for (let lang in labels) {
        if (labels[lang]) return labels[lang]
    }
    return tag.id
}
